import React from "react"
interface IProps {
    readonly?: boolean
    style?: React.CSSProperties
    textStyle?: React.CSSProperties
    underlineStyle?: React.CSSProperties
    text: string
    onClick?(): void
}

const MobileClickableTextField: React.SFC<IProps> = (props: IProps) => {
    let style = { width: "100%", lineHeight: "24px", height: 48, position: "relative" } as React.CSSProperties
    let textStyle = { position: "absolute", opacity: 1, color: "rgba(0, 0, 0, 0.3)", bottom: 12 } as React.CSSProperties
    let underlineStyle = { borderTop: "none rgb(224, 224, 224)", borderLeft: "none rgb(224, 224, 224)", borderRight: "none rgb(224, 224, 224)", borderBottom: "1px solid rgb(224, 224, 224)", bottom: 8, margin: 0, position: "absolute", width: "100%" } as React.CSSProperties
    if (props.style)
        style = { ...style, ...props.style }
    if (props.textStyle)
        textStyle = { ...textStyle, ...props.textStyle }
    if (props.underlineStyle)
        underlineStyle = { ...underlineStyle, ...props.underlineStyle }
    return (
        <div
            style={style}
            onClick={() => !props.readonly && props.onClick && props.onClick()}
        >
            <div style={textStyle}>
                {props.text}
            </div>
            <div>
                <hr style={underlineStyle} />
            </div>
        </div>
    )
}

export default MobileClickableTextField